import { create } from 'zustand';

export interface EventUIState {
  currentStep: string;
  scrollTargetId: string | null;
  forceOpenGroupId: string | null;
  setCurrentStep: (step: string) => void;
  setScrollTargetId: (id: string | null) => void;
  setForceOpenGroupId: (id: string | null) => void;
}

export const useEventUIStore = create<EventUIState>((set) => ({
  currentStep: '',
  scrollTargetId: null,
  forceOpenGroupId: null,
  setCurrentStep: (step) => set({ currentStep: step }),
  setScrollTargetId: (id) => set({ scrollTargetId: id }),
  setForceOpenGroupId: (id) => set({ forceOpenGroupId: id }),
}));
